module.exports = __webpack_public_path__ + "static/media/SD.5aaee1d5.png";